import React from 'react';
import styles from './img-resource.module.scss';

type ImgResourceProps = {
    src: string;
};

export const ImgResource = ({ src }: ImgResourceProps) => {
    return (
        <img
            src={src}
            key={src}
            alt="Chat resource"
            data-testid="img-resource"
            className={styles.resourceImage}
        />
    );
};
